<div
  class="shimmer"
  [style.width]="width"
  [style.height]="this | method: 'shimmerHeight'"
  [style.border-radius]="this | method: 'shimmerBorderRadius'"
  [class.rtl]="direction === 'rtl'"></div>
